import React from 'react';

const TEAM_SIZES = [
  { id: 'solo', label: 'Just me', desc: 'Solo operator' },
  { id: '2-5', label: '2–5', desc: 'Small team' },
  { id: '6-15', label: '6–15', desc: 'Growing team' },
  { id: '15+', label: '15+', desc: 'Large team' },
];

const REFERRAL_SOURCES = [
  { id: 'google', label: 'Google' },
  { id: 'referral', label: 'Referral' },
  { id: 'social', label: 'Social Media' },
  { id: 'other', label: 'Other' },
];

const BusinessDetailsStep = ({ data, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-foreground">Tell us about your business</h2>
        <p className="text-muted-foreground mt-2">Help us personalize your CRM experience.</p>
      </div>
      <div className="space-y-5 max-w-md mx-auto">
        {/* Business Name */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5">Business Name</label>
          <input
            type="text"
            value={data?.businessName || ''}
            onChange={(e) => onChange('businessName', e?.target?.value)}
            placeholder="Your business name"
            className="w-full px-3 py-2.5 border border-border rounded-lg bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {/* Service Area */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5">Primary Service Area / City</label>
          <input
            type="text"
            value={data?.serviceArea || ''}
            onChange={(e) => onChange('serviceArea', e?.target?.value)}
            placeholder="e.g. Los Angeles, CA"
            className="w-full px-3 py-2.5 border border-border rounded-lg bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {/* Team Size */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Team Size</label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {TEAM_SIZES?.map((size) => (
              <button
                key={size?.id}
                onClick={() => onChange('teamSize', size?.id)}
                className={`flex flex-col items-center p-3 rounded-lg border-2 transition-all ${
                  data?.teamSize === size?.id
                    ? 'border-primary bg-primary/5 text-primary' :'border-border hover:border-primary/40 text-foreground'
                }`}
              >
                <span className="text-sm font-bold">{size?.label}</span>
                <span className="text-xs text-muted-foreground mt-0.5">{size?.desc}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Referral Source */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">How did you hear about Wilcart?</label>
          <div className="grid grid-cols-2 gap-2">
            {REFERRAL_SOURCES?.map((source) => (
              <button
                key={source?.id}
                onClick={() => onChange('referralSource', source?.id)}
                className={`py-2.5 px-3 rounded-lg border-2 text-sm font-medium transition-all ${
                  data?.referralSource === source?.id
                    ? 'border-primary bg-primary/5 text-primary' :'border-border hover:border-primary/40 text-foreground'
                }`}
              >
                {source?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessDetailsStep;
